export const CARBON_NAME = 'CO2';
export const LEASE_RATE_NAME = 'Lease Rate';
export const isSpecialRevenueStream = (name) =>
  [CARBON_NAME, LEASE_RATE_NAME].includes(name);
